import React, { useEffect } from "react"
import Layout from "~/components/Layout";
import { useLang } from "~/hooks/useLang";
import AuditUserActionTable from "../components/UserActions";

export default function AuditUserActions() {
    const { translate } = useLang();

    useEffect(() => {
        document.title = translate('User Actions Audit in occurrence - Dispatch System')
    }, [])
    return (
        <Layout marginLayout={true}>
            <AuditUserActionTable />
        </Layout>
    )
}